/**
 * Ctrl+S（Mac は Cmd+S）か。Shift / Alt 併用と IME 変換中は除く
 * @param {KeyboardEvent} e
 */
export const isSaveShortcut = (e) => (
    (e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey && !e.isComposing
    && typeof e.key === 'string' && e.key.toLowerCase() === 's'
);

/**
 * Ctrl+Enter（Mac は Cmd+Enter）か。Shift / Alt 併用と IME 変換中は除く
 * @param {KeyboardEvent} e
 */
export const isSubmitShortcut = (e) => (
    (e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey && !e.isComposing && e.key === 'Enter'
);

// Mac かどうか（ショートカット表記の切り替え用）
export const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || '');

/**
 * ショートカットの表記（Windows: Ctrl+S / Mac: ⌘S）
 * @param {string} key Ctrl / ⌘ と組み合わせるキー（例: 'S'）
 */
export const shortcutLabel = (key, isMac = IS_MAC) => (isMac ? '⌘' + key : 'Ctrl+' + key);
